import { proxy } from 'valtio';

/**
 * In-progress add-listing / host edit draft.
 * Intentionally loose so lean `addNewCar` / `getMyDraftCar` / `updateCar` payloads fit
 * without pulling the fat platform-wide GetCars selection.
 */
export type EditingCarDraft = {
  id: string;
  name?: string | null;
  displayName?: string | null;
  vin?: string | null;
  make?: string | null;
  model?: string | null;
  year?: number | null;
  seats?: number | null;
  gearType?: string | null;
  gas?: string | null;
  licensePlate?: string | null;
  licensePlateState?: string | null;
  gasGrade?: string | null;
  cityMpg?: number | null;
  hwyMpg?: number | null;
  doors?: number | null;
  description?: string | null;
  category?: string | null;
  isCreated?: boolean | null;
  locationId?: number | null;
  ownerId?: string | null;
  currentLocation?: string | null;
  weekdayPrice?: number | null;
  weekendPrice?: number | null;
  holidayPrice?: number | null;
  hourlyRentalIsOn?: boolean | null;
  weekdayHrPrice?: number | null;
  weekendHrPrice?: number | null;
  holidayHrPrice?: number | null;
  monthlyRentalIsOn?: boolean | null;
  monthlyPrice?: number | null;
  monthlyPrice2Months?: number | null;
  monthlyPrice3Months?: number | null;
  thumbnailUrl?: string | null;
  originalPrice?: number | null;
  productTypeDetails?: { id?: string | null; type?: string | null } | null;
  location?: {
    id?: number | null;
    address?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
  } | null;
  distanceLimit?: {
    dailyDistanceLimit?: number | null;
    unlimitedMileage?: boolean | null;
    monthlyDistanceLimit?: number | null;
    monthlyUnlimitedMileage?: boolean | null;
  } | null;
  priceCalendar?: unknown;
  discount?: unknown;
  tripPreferences?: unknown;
  owner?: unknown;
  [key: string]: unknown;
};

interface CarState {
  editingCarId: string | null;
  editingCar: EditingCarDraft | null;
}

export const carStore = proxy<CarState>({
  editingCarId: null,
  editingCar: null,
});

export const carActions = {
  startEditing: (carId: string, car: EditingCarDraft) => {
    carStore.editingCarId = carId;
    carStore.editingCar = car;
  },

  stopEditing: () => {
    carStore.editingCarId = null;
    carStore.editingCar = null;
  },
};
